import { uniq } from "lodash-es";
import * as THREE from "three/webgpu";

export function disposeMesh(mesh: THREE.Object3D): void {
  // first, must remove all parent references
  const meshes = unpackMeshes(mesh);

  const geoms = uniq(meshes.map((m) => m.geometry));
  const materials = uniq(meshes.flatMap((m) => m.material));

  for (const geom of geoms) {
    geom.dispose();
  }
  for (const material of materials) {
    try {
      material.dispose();
    } catch (e) {
      console.error("Failed to dispose material", material, e);
    }
  }
}

function unpackMeshes(obj: THREE.Object3D, out: THREE.Mesh[] = []) {
  obj.removeFromParent();
  if (isMesh(obj)) out.push(obj);
  else if (obj instanceof THREE.Group) {
    for (const child of obj.children) {
      unpackMeshes(child, out);
    }
  }
  return out;
}

function isMesh(mesh: THREE.Object3D): mesh is THREE.Mesh {
  return mesh instanceof THREE.Mesh;
}

export const tmpColor = new THREE.Color();

export const tmpObject = new THREE.Object3D();
tmpObject.matrixAutoUpdate = false;
Object.freeze(tmpObject.quaternion);
Object.freeze(tmpObject.rotation);

const zeroedObject = new THREE.Object3D();
zeroedObject.matrixAutoUpdate = false;
zeroedObject.scale.set(0, 0, 0);
zeroedObject.position.set(0, 0, 0);
zeroedObject.updateMatrix();
export const ZEROED_MATRIX = Object.freeze(zeroedObject.matrix);

export const tmpVector3 = new THREE.Vector3();
